import { ChangeEvent, FC, FormEvent } from 'react';
import { Button } from '../../Atoms';
import { Stack } from '@mui/material';
import { TextField } from '../../../../ui';

interface IProps {
    email: string;
    emailError: boolean;
    handleEmailChange: (event: ChangeEvent) => void;
    handleReset: (event: FormEvent) => void;
    handleBackToSignIn: () => void;
    useCardLayout?: boolean;
}

const fieldSx = {
    pb: 1,
    '.MuiInputLabel-shrink': {
        top: -8,
    },
};

const cardFieldSx = {
    ...fieldSx,
    width: '100%',
};

const ForgotPasswordForm: FC<IProps> = ({
    email,
    emailError,
    handleEmailChange,
    handleReset,
    handleBackToSignIn,
    useCardLayout = false,
}) => {
    if (useCardLayout) {
        return (
            <form onSubmit={handleReset}>
                <Stack spacing={2}>
                    <TextField
                        stacked
                        id="transcepta-change-password-email"
                        label="Email"
                        type="email"
                        value={email}
                        error={emailError}
                        onChange={handleEmailChange}
                        sx={cardFieldSx}
                    />
                    <Button
                        type="button"
                        variant="text"
                        fullWidth
                        onClick={handleBackToSignIn}
                        testid="login-page-back-to-sign-in-button"
                        sx={{
                            textTransform: 'none',
                            justifyContent: 'center',
                            py: 1,
                        }}
                    >
                        Back to Sign In
                    </Button>
                    <Button type="submit" variant="default" fullWidth testid="login-page-reset-password-button">
                        Reset
                    </Button>
                </Stack>
            </form>
        );
    }

    return (
        <form onSubmit={handleReset}>
            <TextField
                stacked
                id="transcepta-change-password-email"
                label="Email"
                type="email"
                color="secondary"
                value={email}
                error={emailError}
                onChange={handleEmailChange}
                sx={fieldSx}
            />
            <Stack direction="row" justifyContent="flex-end" gap={1}>
                <Button variant="secondary" onClick={handleBackToSignIn}>
                    Back to Sign In
                </Button>
                <Button type="submit">Reset</Button>
            </Stack>
        </form>
    );
};

export default ForgotPasswordForm;
